import { HidePreviewTypes } from '../constants/hide-preview-types.const';

export const showPreview = (type: string): boolean => {
  return !HidePreviewTypes.includes(type);
};
